import { render } from "./NoPage.vue?vue&type=template&id=b685462c&scoped=true"
import script from "./NoPage.vue?vue&type=script&lang=js"
export * from "./NoPage.vue?vue&type=script&lang=js"

import "./NoPage.vue?vue&type=style&index=0&id=b685462c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b685462c"]])

export default __exports__